/**
 * Article
 */

import articleContentImageGalleryCarousel from '../lib/article-content-image-gallery-carousel';

articleContentImageGalleryCarousel();
